module.exports = __webpack_public_path__ + "img/logo-menu.ad321ef3.png";